import * as React from 'react';
import {Droppable} from 'react-beautiful-dnd';
import {connect} from 'react-redux';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';
import type {NutshellState} from '../../../../store';

import {getHoveredStageId} from '../../ui-selectors';

import {SalesAutomationNewCard} from '../cards/sales-automation-new-card';

import {CardsErrorState} from './cards-error-state';

import styles from './cards-container.module.css';

function mapStateToProps(state: NutshellState): StateProps {
    return {
        stageIdBeingHovered: getHoveredStageId(state),
    };
}

type OwnProps = {
    parentId: string;
    type: SalesAutomationItemType;
    hideAddCard: boolean;
    isCardBeingDragged: boolean;
    children?: React.ReactNode;
    isLoading: boolean;
    // @ts-expect-error
    errorMessage: string | React.ReactElement<React.ComponentProps<string>> | null | undefined;
};

type StateProps = {
    stageIdBeingHovered: string | null | undefined;
};

type Props = OwnProps & StateProps;

// This must extend Component rather than PureComponent while it remains the
// direct parent of Droppable. Otherwise we have issues with dropping things
// in positions outside the original viewport
export class CardsContainerComponent extends React.Component<Props> {
    render() {
        let containerChild = (
            <Droppable droppableId={this.props.parentId} type={this.props.type}>
                {(provided, snapshot) => (
                    <div ref={provided.innerRef} className={styles['container-draggable']}>
                        <div
                            className={
                                snapshot.isDraggingOver
                                    ? styles['column-container--drag-over']
                                    : styles['column-container']
                            }
                        >
                            {this.props.children}
                            <div
                                className={
                                    this.props.isCardBeingDragged
                                        ? styles['empty-section--hidden']
                                        : styles['empty-section']
                                }
                            >
                                <SalesAutomationNewCard
                                    parentId={this.props.parentId}
                                    type={this.props.type}
                                    isHidden={this.props.hideAddCard}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </Droppable>
        );

        // If we don't already have any cards to show, show a spinner while we're loading
        const isInitialLoad = React.Children.count(this.props.children) === 0;
        if (this.props.isLoading && isInitialLoad) {
            containerChild = (
                <div className={styles['loading-container']}>
                    <LoadingIcon size={28} />
                </div>
            );
        } else if (this.props.errorMessage) {
            containerChild = <CardsErrorState errorMessage={this.props.errorMessage} />;
        }

        return (
            <div
                className={
                    this.props.stageIdBeingHovered === this.props.parentId
                        ? styles['container--highlighted']
                        : styles.container
                }
            >
                {containerChild}
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const CardsContainer = connector(CardsContainerComponent);
